import enrollmentCoursesRepository from '@/domain/repositories/EnrollmentCoursesRepository';
import EnrollmentCoursesDataStoreFactory from '../factories/EnrollmentCoursesDataStoreFactory';
import EnrollmentCoursesDataStore from '../datastores/EnrollmentCoursesStore';

export default class EnrollmentCoursesRepository
  implements enrollmentCoursesRepository
{
  getEnrollmentCourses(
    campus: string,
    career: string,
    plan: string,
    prog: string,
    period: string
  ) {
    const enrollmentCoursesDataStore: EnrollmentCoursesDataStore =
      EnrollmentCoursesDataStoreFactory.create();
    return enrollmentCoursesDataStore.getEnrollmentCourses(
      campus,
      career,
      plan,
      prog,
      period
    );
  }
}
